import React from "react";
import { ShieldOff } from "lucide-react";

export function NoProjectAccess() {
  return (
    <div className="max-w-xl mx-auto mt-16 text-center fade-up" data-testid="no-project-access">
      <ShieldOff className="h-10 w-10 text-[#B9D6CE] mx-auto" />
      <h2 className="mt-6 text-2xl font-heading font-bold text-[#212121]">No portfolio access yet</h2>
      <p className="mt-3 text-sm text-[#4D4D4D]">
        Your account is active, but an administrator has not granted you access to any project.
        Please contact your KOIOC administrator to get your dashboards enabled.
      </p>
    </div>
  );
}
